<template>
  <v-dialog v-model="visible" max-width="1350px">
    <v-card class="overflow-y-hidden">
      <v-card-title class="d-flex align-center">
        <span>ESTIMACIÓN DE INGRESOS POR SEDE GESTIÓN {{ gestion?.numero }}</span>

        <v-btn small class="ml-4" @click="descargarEstimacionesReporte">
          <v-icon>mdi-microsoft-excel</v-icon>

          Exportar
        </v-btn>
      </v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-tabs>
          <v-tab> REPORTE POR PROGRAMA </v-tab>
          <v-tab> TOTALES POR PROGRAMA </v-tab>
          <v-tab> TOTALES POR CUENTA </v-tab>

          <v-tab-item class="item-tab">
            <ReportePorPrograma :estimaciones="estimaciones" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <TotalesPorPrograma :estimaciones="estimaciones" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <TotalesPorPartida :estimacionesPorPartidas="estimacionesPorPartidas" />
          </v-tab-item>
        </v-tabs>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ReportePorPrograma from './VerEstimacionIngresosPorSede/ReportePorPrograma.vue';
import TotalesPorPrograma from './VerEstimacionIngresosPorSede/TotalesPorPrograma.vue';
import TotalesPorPartida from './VerEstimacionIngresosPorSede/TotalesPorPartida.vue';
import IngresosServices from '../services/ingresos';
import { formatearNumero } from './../utils';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';

export default {
  name: 'VerEstimacionIngresosPorSede',
  mixins: [DescargarExcelMixin],
  components: {
    ReportePorPrograma,
    TotalesPorPrograma,
    TotalesPorPartida,
  },
  data() {
    return {
      gestion: null,
      visible: false,
      estimaciones: [],
      estimacionesPorPartidas: [],
    };
  },
  methods: {
    abrir(gestion) {
      this.gestion = gestion;
      this.visible = true;
      this.estimaciones = [];
      this.estimacionesPorPartidas = [];
      this.listarEstimaciones();
      this.listarEstimacionesPorPartidas();
    },
    cerrar() {
      this.visible = false;
      this.estimaciones = [];
      this.estimacionesPorPartidas = [];
    },
    async listarEstimaciones() {
      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestion?.id,
        };
        const response = await IngresosServices.get({ params });

        this.estimaciones = response.data.datos;
      } catch (error) {
        window.console.log(error);
      }
    },
    async listarEstimacionesPorPartidas() {
      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestion?.id,
        };
        const response = await IngresosServices.getPorPartidas({ params });

        this.estimacionesPorPartidas = response.data.datos;
      } catch (error) {
        window.console.log(error);
      }
    },
    formatearNumero(numero) {
      return formatearNumero(numero);
    },
    descargarEstimacionesReporte() {
      const opciones = {
        params: {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestion?.id,
        },
      };

      return this.descargarExcel(ReportesExcelService.estimacionesReporte, null, opciones);
    },
  },
  computed: {},
};
</script>

<style scoped>
.item-tab {
  max-height: calc(100vh - 19rem);
  min-height: calc(100vh - 19rem);
  overflow-y: auto;
}
</style>